import { apiRequest } from './client';

// Customer change requests on bookings made through the website (see /api/amendments).
// Guests identify themselves with the booking email; signed-in owners need only the booking id.

export const amendmentTypes = [
  ['Cancellation', 'Cancel booking'],
  ['DateChange', 'Change date'],
  ['NameCorrection', 'Correct a name'],
  ['TravellerChange', 'Change travellers'],
  ['SpecialRequest', 'Special request'],
  ['Other', 'Something else'],
];

export const amendmentTypeLabel = Object.fromEntries(amendmentTypes);

export const amendmentStatusLabel = {
  Open: 'Received',
  InProgress: 'In progress',
  AwaitingCustomer: 'Waiting for reply',
  Completed: 'Completed',
  Rejected: 'Declined',
};

export const listAmendments = (supplierBookingId, email, token, signal) => {
  const search = new URLSearchParams({ supplierBookingId });
  if (email && !token) search.set('email', email);
  return apiRequest(`/api/amendments?${search}`, { token, signal });
};

/** request: { supplierBookingId, email?, type, message } */
export const createAmendment = (request, token) => apiRequest('/api/amendments', { body: request, token });

export const replyToAmendment = (id, text, email, token) =>
  apiRequest(`/api/amendments/${id}/messages`, { body: { text, ...(token ? {} : { email }) }, token });
